module.exports = __webpack_public_path__ + "static/img/culture-6.4f703b6a.png";